import { Avatar } from "@carrotfertility/carotene-core"
import React from "react"
import { formatProviderInitials } from "./formatting"

export function AppointmentsAvatar({
  name,
  photoUrl,
  alt
}: {
  name: string
  photoUrl: string | null
  alt?: string
}): JSX.Element {
  if (photoUrl) {
    return <Avatar variant="rounded" src={photoUrl} alt={alt ?? name} />
  }

  // TODO: check with design whether to show initials avatars when there is no photo.
  return (
    <Avatar variant="rounded" sx={{ bgcolor: (theme) => theme.palette.warning.contrastText }}>
      {formatProviderInitials(name)}
    </Avatar>
  )
}
